// extracted by mini-css-extract-plugin
export default {"header":"inv-list-header_header__7lfaA","back":"inv-list-header_back__LRFhw","title":"inv-list-header_title__JMLu2"};